import { Box, ImageProps } from '@chakra-ui/react';

export const MediaPreview = ({
  src,
  as,
  containPreview,
  ...imageProps
}: {
  containPreview?: boolean;
} & ImageProps) => (
  <Box
    src={src}
    as={as}
    width="100%"
    height="100%"
    inset={0}
    position="absolute"
    boxSize="100%"
    objectFit={containPreview ? 'contain' : 'cover'}
    p={containPreview ? 'space.16' : 0}
    alt=""
    bg="gray.2"
    {...imageProps}
  />
);
